import React, { Component, Fragment } from "react";
import { Menu, Collapse, Input, Dropdown, Table, Button, Modal } from "antd";
import { DownOutlined, UserOutlined } from "@ant-design/icons";
import Api from "../../ServiceApi";
import Cookies from "js-cookie";

const { Panel } = Collapse;
const { Search } = Input;

const menu = (
  <Menu>
    <Menu.Item key="1" icon={<UserOutlined />}>
      XLS
    </Menu.Item>
    <Menu.Item key="2" icon={<UserOutlined />}>
      PDF
    </Menu.Item>
  </Menu>
);

class BalanceStock extends Component {
  // The first two modal is for showing Area and Sub-Area Code
  state = {
    modalVisible: false,
    modal2Visible: false,
    modal3Visible: false,
  };

  setModalVisible(modalVisible) {
    this.setState({ modalVisible });
  }

  setModal2Visible(modal2Visible) {
    this.setState({ modal2Visible });
  }

  setModal3Visible(modal3Visible) {
    this.setState({ modal3Visible });
  }

  constructor(props) {
    super(props);
    this.state = {
      visible: false,
      title: "Balance Stock",
      step: 0,
      filter: [],
      category: [],
      wh_index_selected: 0,
      wh_zone_index_selected: 0,
      wh_page: 1,
      sorter: "wh_zone_loc_code",
      sortasc: 1,
      dataTemps: [],
      dataSelected: [],
      data: [],
      columns: [],
      data_subarea: [
        // {
        //   key: "1",
        //   partname: "APE01CDPW-0012-XX0",
        //   kkn: 503,
        //   nma: 1000,
        //   umn: 2000,
        //   udn: 502,
        //   ryg: 0,
        //   total: 4005,
        // },
        // {
        //   key: "2",
        //   partname: "APE01OFCF-8024-XX0",
        //   kkn: 1951,
        //   nma: 4001,
        //   umn: 6000,
        //   udn: 2000,
        //   ryg: 0,
        //   total: 13952,
        // },
        // {
        //   key: "3",
        //   partname: "APE12JCLM-0000-XX9",
        //   kkn: 105,
        //   nma: 200,
        //   umn: 200,
        //   udn: 100,
        //   ryg: 0,
        //   total: 605,
        // },
        // {
        //   key: "4",
        //   partname: "APE12PFOM-0070-XX5",
        //   kkn: 88,
        //   nma: 164,
        //   umn: 178,
        //   udn: 60,
        //   ryg: 0,
        //   total: 490,
        // },
      ],
      data_sub_code_area: [
        // {
        //   key: "1",
        //   partname: "APE01CDPW-0012-XX0",
        //   sp32: 100,
        //   code_7201: 200,
        //   code_7202: 100,
        // },
        // {
        //   key: "2",
        //   partname: "APE01OFCF-8024-XX0",
        //   sp32: 100,
        //   code_7201: 200,
        //   code_7202: 100,
        // },
        // {
        //   key: "3",
        //   partname: "APE12JCLM-0000-XX9",
        //   sp32: 100,
        //   code_7201: 200,
        //   code_7202: 100,
        // },
      ],
      data_stock_code: [
        // {
        //   key: "1",
        //   region: "BKK - Bangkok",
        //   location: {
        //     location1: 1501,
        //     location2: 1502,
        //     location3: 1503,
        //     location4: 1504,
        //   },
        //   quantity: {
        //     quantity1: 500,
        //     quantity2: 300,
        //     quantity3: 200,
        //     quantity4: 100,
        //   },
        //   total: {
        //     total1: 1500,
        //     total2: 1000,
        //     total3: 1000,
        //     total4: 800,
        //   },
        //   totalSum: 3000,
        // },
        // {
        //   key: "2",
        //   region: "",
        //   location: {
        //     location1: 1501,
        //     location2: 1502,
        //     location3: 1503,
        //     location4: 1504,
        //   },
        //   quantity: {
        //     quantity1: 500,
        //     quantity2: 300,
        //     quantity3: 200,
        //     quantity4: 100,
        //   },
        //   total: {
        //     total1: 1500,
        //     total2: 1000,
        //     total3: 1000,
        //     total4: 800,
        //   },
        // },
        // {
        //   key: "3",
        //   region: "",
        //   location: {
        //     location1: 1501,
        //     location2: 1502,
        //     location3: 1503,
        //     location4: 1504,
        //   },
        //   quantity: {
        //     quantity1: 500,
        //     quantity2: 300,
        //     quantity3: 200,
        //     quantity4: 100,
        //   },
        //   total: {
        //     total1: 1500,
        //     total2: 1000,
        //     total3: 1000,
        //     total4: 800,
        //   },
        // },
      ],
    };
  }

  async componentDidMount() {
    await Api.post("materialstockP_WH_GET_MATERIAL_SUMMARY", {
      //company_id: "1",
      company_id: Cookies.get("companyid"),
      operator_id: Cookies.get("operator_id"),
      project_id: "1",
      wh_id: "",
      wh_zone_id: "",
      wh_zone_loc_id: "",
    }).then(({ data }) => {
      const result = data.data.table;
      this.tableToLevel1(result);
      this.setState({
        dataTemps: result,
      });
    });
  }

  tableToLevel1(items) {
    const key = {
      level: "wh_lv1_code",
      material: "material_code",
      count: "total_qty_min",
    };
    console.log(items);
    const groupArea = this.groupBy(items, key.level);
    const groupMaterial = this.groupBy(items, key.material);
    let mapColumns = Object.keys(groupArea).map((item) => {
      return {
        title: item,
        key: item,
        dataIndex: item,
        align: "right",
        render: (record) => {
          const text = !record ? 0 : this.sum(record, key.count);
          return text;
        },
      };
    });
    mapColumns.unshift({
      title: "Name",
      width: 200,
      key: "name",
      dataIndex: "name",
      render: (text) => text,
    });
    mapColumns.push({
      title: "Grand Total",
      width: 150,
      align: "right",
      key: "total",
      dataIndex: "total",
      render: (text) => text,
    });

    const newData = Object.entries(groupMaterial).map((item, index) => {
      const area = this.groupBy(item[1], key.level);
      return {
        ...area,
        key: index,
        name: item[0],
        total: this.sum(item[1], key.count),
      };
    });

    this.setState({
      columns: mapColumns,
      data: newData,
      step: 0,
      filter: groupArea,
    });
  }

  tableToLevel2(step, data) {
    const key = {
      level: "wh_lv2_code",
      material: "material_code",
      count: "total_qty_min",
    };
    const groupLevel2 = this.groupBy(data[1], key.level);
    const groupMaterial = this.groupBy(data[1], key.material);
    let mapColumns = Object.keys(groupLevel2).map((item) => {
      return {
        title: item,
        key: item,
        dataIndex: item,
        align: "right",
        render: (record) => {
          const text = !record ? 0 : this.sum(record, key.count);
          return text;
        },
      };
    });
    mapColumns.unshift({
      title: "Name",
      width: 200,
      key: "name",
      dataIndex: "name",
      render: (text) => text,
    });
    mapColumns.push({
      title: "Grand Total",
      width: 150,
      align: "right",
      key: "total",
      dataIndex: "total",
      render: (text) => text,
    });

    const newData = Object.entries(groupMaterial).map((item, index) => {
      const area = this.groupBy(item[1], key.level);
      return {
        ...area,
        key: index,
        name: item[0],
        total: this.sum(item[1], key.count),
      };
    });

    this.setState({
      columns: mapColumns,
      data: newData,
      dataSelected: data,
      step: step,
      filter: groupLevel2,
    });
  }

  tableToLevel3(step, data) {
    const key = {
      level: "wh_lv3_code",
      material: "material_code",
      count: "total_qty_min",
    };
    const groupLevel3 = this.groupBy(data[1], key.level);
    const groupMaterial = this.groupBy(data[1], key.material);
    let mapColumns = Object.keys(groupLevel3).map((item) => {
      return {
        title: item,
        key: item,
        dataIndex: item,
        align: "right",
        render: (record) => {
          const text = !record ? 0 : this.sum(record, key.count);
          return text;
        },
      };
    });
    mapColumns.unshift({
      title: "Name",
      width: 200,
      key: "name",
      dataIndex: "name",
      render: (text) => text,
    });
    mapColumns.push({
      title: "Grand Total",
      width: 150,
      align: "right",
      key: "total",
      dataIndex: "total",
      render: (text) => text,
    });

    const newData = Object.entries(groupMaterial).map((item, index) => {
      const area = this.groupBy(item[1], key.level);
      return {
        ...area,
        key: index,
        name: item[0],
        total: this.sum(item[1], key.count),
      };
    });

    this.setState({
      columns: mapColumns,
      data: newData,
      dataSelected: data,
      step: step,
    });
  }

  toJson(jsonString) {
    let myJSONString = JSON.parse(JSON.stringify(jsonString.data.data));
    return JSON.parse(myJSONString);
  }

  groupBy = function (xs, key) {
    return (!xs ? [] : xs).reduce(function (rv, x) {
      (rv[x[key]] = rv[x[key]] || []).push(x);
      return rv;
    }, {});
  };
  // onFilter(step, wh_index, wh_zone) {
  //     this.setState({
  //         wh_index_selected: wh_index,
  //         wh_zone_index_selected: wh_zone,
  //         step: step
  //     });
  // }

  // onSort = (e) => {
  //     let thisasc = this.state.sortasc;
  //     function compare(a, b) {
  //         if (a[e] < b[e]) {
  //             return thisasc === 1 ? -1 : 1;
  //         }
  //         if (a[e] > b[e]) {
  //             return thisasc === 1 ? 1 : -1;
  //         }
  //         return 0;
  //     }
  //     let sortedfilter = this.state.data.sort(compare);
  //     this.setState({
  //         data: sortedfilter,
  //         sorter: e
  //     });
  // }

  // dataFiltered(wh_id, wh_zone_id) {
  //     let thisdata = this.state.data;
  //     let thisfilter = {
  //         wh_id: wh_id,
  //         wh_zone_id: wh_zone_id
  //     };
  //     let thisstep = this.state.step;
  //     return this.state.data.filter(function (obj) {
  //         if (wh_id === 0) {
  //             return true;
  //         } else if (wh_zone_id === 0) {
  //             return obj.wh_id === wh_id ? true : false;
  //         } else {
  //             return obj.wh_id === wh_id && obj.wh_zone_id === wh_zone_id ? true : false;
  //         }
  //     });
  // }
  sum(array, key) {
    return (!array ? [] : array).reduce((a, b) => a + (b[key] || 0), 0);
  }

  openModal = (visible, item) => {
    this.setState({ modal3Visible: true });
  };

  render() {
    const {
      title,
      data,
      data_subarea,
      data_sub_code_area,
      data_stock_code,
      columns,
      step,
      filter,
      dataTemps,
      dataSelected,
    } = this.state;
    function arrObjhandler(a, b) {
      let res = !a ? {} : a[0];
      return res[b];
    }
    const key = {
      2: "wh_lv1_code",
      material: "material_code",
      count: "total_qty_min",
    };
    const mergeData = this.groupBy(Object.values(filter).flat(), key[step]);
    const parentData = [...Object.keys(mergeData), ...Object.values(mergeData)];

    return (
      <div className="container-fluid">
        <div
          className="row"
          style={{ fontSize: 14, marginLeft: 15, padding: "15px 10px" }}
        >
          <div className="col-6">
            <div style={{ fontSize: 20, fontWeight: 600 }}>
              <span className="totalitems">
                {this.sum(dataTemps, key.count)}
              </span>
              {" items in "}
              <span className="area" style={{ color: "#7123F7" }}>
                All Area
              </span>
            </div>
          </div>
          <div className="col-6" style={{ textAlign: "right" }}>
            <Dropdown.Button
              overlay={menu}
              placement="bottomCenter"
              icon={<DownOutlined />}
            >
              Export
            </Dropdown.Button>
          </div>
        </div>
        <div className="row">
          <div className="col-3">
            <div className="menu-warehouse">
              <Collapse accordion defaultActiveKey={["1"]}>
                <Panel header="Area Warehouse" key="1">
                  {step === 0 ? (
                    <ul className="filter-warehouse">
                      <li className="title">
                        <span>All Area</span>
                        <span className="total">
                          {this.sum(dataTemps, key.count)}
                        </span>
                      </li>
                      {Object.entries(filter).map((item, index) => (
                        <li key={index}>
                          <button onClick={() => this.tableToLevel2(1, item)}>
                            <span>{item[0]}</span>
                            <span className="total">
                              {this.sum(item[1], key.count)}
                            </span>
                          </button>
                        </li>
                      ))}
                    </ul>
                  ) : null}
                  {step === 1 ? (
                    <ul className="filter-warehouse">
                      <li className="title">
                        <button onClick={() => this.tableToLevel1(dataTemps)}>
                          <span>
                            <img
                              src={Api.absoluteUrl("/icon/arrow_left.png")}
                              alt=""
                              className="mr-2"
                            />
                            All Area
                          </span>
                          <span className="total">
                            {this.sum(dataTemps, key.count)}
                          </span>
                        </button>
                      </li>
                      <li className="title">
                        <span>{dataSelected[0]}</span>
                        <span className="total">
                          {this.sum(dataSelected[1], key.count)}
                        </span>
                      </li>
                      {Object.entries(filter).map((item, index) => {
                        return (
                          <li key={index}>
                            <button onClick={() => this.tableToLevel3(2, item)}>
                              <span>{item[0]}</span>
                              <span className="total">
                                {this.sum(item[1], key.count)}
                              </span>
                            </button>
                          </li>
                        );
                      })}
                    </ul>
                  ) : null}
                  {step === 2 ? (
                    <ul className="filter-warehouse">
                      <li className="title">
                        <button onClick={() => this.tableToLevel1(dataTemps)}>
                          <span>
                            <img
                              src={Api.absoluteUrl("/icon/arrow_left.png")}
                              alt=""
                              className="mr-2"
                            />
                            All Area
                          </span>
                          <span className="total">
                            {this.sum(dataTemps, key.count)}
                          </span>
                        </button>
                      </li>
                      <li className="title">
                        <button
                          onClick={() => this.tableToLevel2(1, parentData)}
                        >
                          <span>
                            <img
                              src={Api.absoluteUrl("/icon/arrow_left.png")}
                              alt=""
                              className="mr-2"
                            />
                            {parentData[0]}
                          </span>
                          <span className="total">
                            {this.sum(parentData[1], key.count)}
                          </span>
                        </button>
                      </li>
                      <li className="title">
                        <span>{dataSelected[0]}</span>
                        <span className="total">
                          {this.sum(dataSelected[1], key.count)}
                        </span>
                      </li>
                    </ul>
                  ) : null}
                </Panel>
              </Collapse>
            </div>
          </div>

          <div className="col-9">
            <div className="card-table-ma" style={{ padding: "25px 30px" }}>
              <div className="d-flex justify-content-between align-items-center mb-4">
                <div className="col-6">
                  <span className="font-mont-r fs-12">Area</span>
                  {
                    {
                      0: (
                        <h3 className="font-mont-sb fs-18 c-blue mb-0">
                          All Area
                        </h3>
                      ),
                      1: (
                        <h3 className="font-mont-sb fs-18 c-blue mb-0">
                          {dataSelected[0]}
                        </h3>
                      ),
                      2: (
                        <h3 className="font-mont-sb fs-18 c-blue mb-0">
                          {dataSelected[0]}
                        </h3>
                      ),
                    }[step]
                  }
                </div>

                <div className="col-4">
                  <Search
                    placeholder="Please Insert Partname"
                    onSearch={(value) => console.log(value)}
                    enterButton
                  />
                </div>
              </div>
              <div className="body mt-3">
                <div style={{ marginLeft: "15px", marginRight: "15px" }}>
                  <Table
                    columns={columns}
                    dataSource={data}
                    scroll={{ x: 1000 }}
                    onChange={this.handleChange}
                    // onRow={(record, rowIndex) => {
                    //   return {
                    //     onClick: (event) => {
                    //       this.setModal3Visible(true);
                    //     },
                    //   };
                    // }}
                  />

                  <div
                    style={{
                      height: "36px",
                      marginTop: "10px",
                      top: "1000px",
                      position: "absolute",
                      color: "#6F6F6F",
                    }}
                  >
                    <span>Showing</span>
                    <span style={{ marginLeft: "5px" }}>1</span>
                    <span style={{ marginLeft: "5px" }}>To</span>
                    <span style={{ marginLeft: "5px" }}>10</span>
                    <span style={{ marginLeft: "5px" }}>Of</span>
                    <span style={{ marginLeft: "5px" }}>1,000</span>
                    <span style={{ marginLeft: "5px" }}>Entries</span>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* <Button type="primary" onClick={() => this.setModalVisible(true)}>
                        For Testing Sub Area Column
                    </Button>                */}
          {/* <Modal 
                        visible={this.state.modalVisible}
                        onOk={() => this.setModalVisible(false)}
                        onCancel={() => this.setModalVisible(false)} 
                        width={"auto"}
                        >
                        <div className="col">
                                    <div className="d-flex justify-content-between align-items-center mb-4">
                                        <div className="col-6">
                                            <span className="font-mont-r fs-12">Area</span>
                                            {
                                                {
                                                         0: <h3 className="font-mont-sb fs-18 c-blue mb-0">NORTHEAST</h3>
                                                }[step]
                                            }       
                                        </div>  
                                    </div> 
                                    <div className="body mt-3">
                                            <div style={{ marginLeft: "15px", marginRight: "15px" }}>
                                                <Table 
                                                    columns={columns_subarea}
                                                    dataSource={data_subarea}
                                                    scroll={{ x: 1000 }} 
                                                    onChange={this.handleChange}
                                                />

                                                <div style={{ height: "36px", marginTop: "10px", top: "1000px", position: "absolute", color: "#6F6F6F" }}>
                                                    <span>Showing</span>
                                                    <span style={{ marginLeft: "5px" }}>1</span>
                                                    <span style={{ marginLeft: "5px" }}>To</span>
                                                    <span style={{ marginLeft: "5px" }}>10</span>
                                                    <span style={{ marginLeft: "5px" }}>Of</span>
                                                    <span style={{ marginLeft: "5px" }}>1,000</span>
                                                    <span style={{ marginLeft: "5px" }}>Entries</span>
                                                </div>
                                            </div>
                                        </div>           
                                </div>
                    </Modal> */}
          {/* <Button type="primary" onClick={() => this.setModal2Visible(true)}>
                        For Testing Sub Area Column Code
                    </Button> */}
          {/* <Modal 
                        visible={this.state.modal2Visible}
                        onOk={() => this.setModal2Visible(false)}
                        onCancel={() => this.setModal2Visible(false)} 
                        width={"auto"}
                        >
                        <div className="col">
                                    <div className="d-flex justify-content-between align-items-center mb-4">
                                        <div className="col-6">
                                            <span className="font-mont-r fs-12">Area</span>
                                            {
                                                {
                                                         0: <h3 className="font-mont-sb fs-18 c-blue mb-0">NORTHEAST: KNN</h3>
                                                }[step]
                                            }       
                                        </div>  
                                    </div> 
                                    <div className="body mt-3">
                                            <div style={{ marginLeft: "15px", marginRight: "15px" }}>
                                                <Table 
                                                    columns={columns_subarea}
                                                    dataSource={data_subarea}
                                                    scroll={{ x: 1500 }} 
                                                    onChange={this.handleChange}
                                                />

                                                <div style={{ height: "36px", marginTop: "10px", top: "1000px", position: "absolute", color: "#6F6F6F" }}>
                                                    <span>Showing</span>
                                                    <span style={{ marginLeft: "5px" }}>1</span>
                                                    <span style={{ marginLeft: "5px" }}>To</span>
                                                    <span style={{ marginLeft: "5px" }}>10</span>
                                                    <span style={{ marginLeft: "5px" }}>Of</span>
                                                    <span style={{ marginLeft: "5px" }}>1,000</span>
                                                    <span style={{ marginLeft: "5px" }}>Entries</span>
                                                </div>
                                            </div>
                                        </div>           
                                </div>
                    </Modal> */}

          <Modal
            visible={this.state.modal3Visible}
            onOk={() => this.setModal3Visible(false)}
            onCancel={() => this.setModal3Visible(false)}
            width={"auto"}
            className="custom-modal-map-large"
          >
            <div className="">
              <div className="d-flex justify-content-between align-items-center mb-4">
                <div className="col-6 m-3">
                  <span className="font-mont-r fs-12">Partname</span>
                  {
                    {
                      0: (
                        <h3 className="font-mont-sb fs-18 c-blue mb-0">
                          BKK1-Z41
                        </h3>
                      ),
                    }[step]
                  }
                </div>
              </div>
            </div>
          </Modal>
        </div>
      </div>
    );
  }
}

export default BalanceStock;
